// extracted by mini-css-extract-plugin
module.exports = {"login":"login_login__2PTrZ","shape":"login_shape__3Y0td","providers":"login_providers__2FLTu"};